// 🔒
export default function TrainerJoinSection() {
  return (
    <section className="section trainer-join" id="join-trainers">
      <div className="container">
        <div className="trainer-join__card">
          <div className="trainer-join__glow trainer-join__glow--one" />
          <div className="trainer-join__glow trainer-join__glow--two" />

          <div className="trainer-join__content">
            <p className="eyebrow">JOIN OUR ELEFIT FAMILY</p>
            <h2>Bring your coaching brand into a premium digital experience.</h2>
            <p className="trainer-join__text">
              We partner with ambitious trainers who want to grow beyond
              one-to-one coaching and deliver their programs in a more scalable,
              polished, and professional way. If you have strong expertise, a
              clear training philosophy, and valuable content, we would love to
              explore how we can build something exceptional together.
            </p>

            <div className="trainer-join__actions">
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSeb7o63epuPWnDboWDm0seGD40kOl4Rze0RZcY3YEGsf9EjSg/viewform?usp=header"
                target="_blank"
                rel="noreferrer"
                className="trainer-join__cta"
              >
                Get in Touch
              </a>
              <p className="trainer-join__ctaNote">
                Tell us about your coaching style, programs, and goals.
              </p>
            </div>
          </div>

          <div className="trainer-join__side">
            <div className="trainer-join__points">
              <div className="trainer-join__point">
                <span className="trainer-join__check">✓</span>
                <span>Present your programs in a polished, premium format</span>
              </div>

              <div className="trainer-join__point">
                <span className="trainer-join__check">✓</span>
                <span>Reach more clients and grow your digital presence</span>
              </div>

              <div className="trainer-join__point">
                <span className="trainer-join__check">✓</span>
                <span>Partner with a platform built to support your growth</span>
              </div>

              <div className="trainer-join__point">
                <span className="trainer-join__check">✓</span>
                <span>Zero upfront cost — we do not charge trainers to join the platform</span>
              </div>

            </div>
            <div className="trainer-join__miniCard">
              <p className="trainer-join__miniLabel">Open for collaboration</p>
              <h3>Become one of the featured trainers in the app</h3>
              <p>
                We are looking for coaches with real expertise, quality
                programming, and the ambition to build a stronger long-term
                digital brand.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
// 🔒